export default __webpack_public_path__ + "static/media/Mark-2-Suit-11.90ba9a9e.jpg";